import * as types from './actions/types';

export default (
    state = {
        isListMode: true
    },
    action
) => {
    console.log(action.type);
    switch (action.type) {
        case types.CHANGE_CATALOG_MODE:
            return { ...state, isListMode: action.isListMode };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Catalog/reducer.js